import { Layout } from 'antd';
import React from 'react';
import ProfileDropdown from './ProfileDropdown/ProfileDropdown';
import './AppHeader.scss';

const { Header } = Layout;

const AppHeader = ({ userName }: { userName: string }) => {
  return (
    <Header className="Header">
      <img className="Header__logo" src="/assets/images/logo_teinnova_white.png" alt="Teinnova" />
      <ProfileDropdown userName={userName} />
    </Header>
  );
};

export default AppHeader;
